import { render, staticRenderFns } from "./ModalLampImportNew.vue?vue&type=template&id=0c3112b2&scoped=true"
import script from "./ModalLampImportNew.vue?vue&type=script&lang=js"
export * from "./ModalLampImportNew.vue?vue&type=script&lang=js"
import style0 from "./ModalLampImportNew.vue?vue&type=style&index=0&id=0c3112b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3112b2",
  null
  
)

export default component.exports